export default __webpack_public_path__ + "static/media/no_permissions.1d9acd1a.png";